import { Button } from "antd";
import React, { useState } from "react";

export const SubmitButton = ({ children, loading, item, form }) => {
  const [isThrottled, setIsThrottled] = useState(false);

  const handleClick = event => {
    if (isThrottled === false) {
      setIsThrottled(true); // Désactive le bouton

      form?.submit();

      // Réactive le bouton après 2 secondes
      setTimeout(() => {
        setIsThrottled(false);
      }, 400);
    } else {
      event.preventDefault(); // Empêche la soumission native si nécessaire
      return;
    }
  };

  let isLoading;

  if (item.loading !== undefined) {
    isLoading = item.loading;
  }

  return (
    <Button
      type="primary"
      htmlType="submit"
      size={item.size || "large"}
      loading={isLoading || isThrottled}
      onClick={handleClick} // Utilise handleClick pour gérer le clic avec le délai
      onSubmit={handleClick} // Utilise handleClick pour gérer le clic avec le délai
      disabled={isThrottled} // Désactive le bouton pendant le délai
    >
      {item.label || children}
    </Button>
  );
};
